export const MODAL_WRAPPER_ZINDEX = 1301
export const MENU_WRAPPER_ZINDEX = 1100
export const TWO_FA_MODAL_WRAPPER_ZINDEX = 1401
export const ALERT_WRAPPER_ZINDEX = 1501
